import ApiService from "@/common/api/api.service";

export const BannerService = {
    get(id) {
        ApiService.setHeader()
        return ApiService.getImageBlob(`banners/${id}`)
    },
    list(slug) {
        ApiService.setHeader()
        return ApiService.get('banners', slug)
    },
    create(data) {
        ApiService.setHeader()
        let formData = new FormData();
        formData.append("file", data);
        return ApiService.postFile('banners', formData)
    },
    update(id, data) {
        ApiService.setHeader()
        let formData = new FormData();
        formData.append("file", data);
        return ApiService.putFile(`banners/${id}`, formData)
    },
    delete(id) {
        ApiService.setHeader()
        return ApiService.delete(`banners/${id}`)
    }
}